import { render, staticRenderFns } from "./customerMgt.vue?vue&type=template&id=7dd233ce&scoped=true&"
import script from "./customerMgt.vue?vue&type=script&lang=js&"
export * from "./customerMgt.vue?vue&type=script&lang=js&"
import style0 from "./customerMgt.vue?vue&type=style&index=0&id=7dd233ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd233ce",
  null
  
)

export default component.exports